import React, { useState, useRef } from "react";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Button from "@mui/material/Button";
import { useImportAdoptionDecisions } from "containers/PolicyHistory/usePoliciesReview";
import ContentModal from "components/ContentModal";
import { CloudUpload } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const ImportModal = ({ hpKey, onSubmit }) => {
  const [open, setopen] = useState(false);
  const [quarter, setquarter] = useState("");
  const [year, setyear] = useState("");
  const [file, setfile] = useState(null);
  const [error, seterror] = useState("");
  const fileRef = useRef(null);

  const handleClose = () => {
    setopen(false);
    setyear("");
    setquarter("");
    setfile(null);
    seterror("");
    fileRef.current.value = "";
  };

  const [importAdoptionDecisions] = useImportAdoptionDecisions();

  const onImport = () => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("year", year);
    formData.append("quarter", quarter);

    importAdoptionDecisions(
      hpKey,
      formData,
      () => {
        onSubmit();
        handleClose();
      },
      (errorMessage) => {
        seterror(errorMessage || "Failed to import adoption decisions.");
      }
    );
  };
  const handleFileChange = () => {
    const selectedFile = fileRef.current?.files[0];
    if (selectedFile) {
      setfile(selectedFile);
    }
  };
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);
  return (
    <Box sx={{ minWidth: 120 }}>
      <ContentModal
        handleClose={handleClose}
        content={
          <Grid sx={{ mt: "10px" }} container spacing={1}>
            <Grid item xs={6} flexDirection={"row"} display={"flex"} gap={1}>
              <FormControl fullWidth>
                <InputLabel id="quarter">Quarter</InputLabel>
                <Select
                  id="quarter"
                  label="Quarter"
                  value={quarter}
                  sx={{ width: "100px" }}
                  onChange={(e) => setquarter(e.target.value)}
                >
                  {["Q1", "Q2", "Q3", "Q4"].map((quarter) => (
                    <MenuItem key={quarter} value={quarter}>
                      {quarter}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="year">Year</InputLabel>
                <Select
                  id="year"
                  label="Year"
                  sx={{ width: "100px" }}
                  value={year}
                  onChange={(e) => setyear(e.target.value)}
                >
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                color="primaryButton"
                disableElevation
                sx={{ mr: "10px" }}
                startIcon={<CloudUpload />}
              >
                Upload file
                <VisuallyHiddenInput
                  type="file"
                  ref={fileRef}
                  onChange={handleFileChange}
                />
              </Button>
              {file && file.name}
            </Grid>
            {error && (
              <Grid item xs={12} sx={{ color: "red" }}>
                {error}
              </Grid>
            )}
          </Grid>
        }
        actions={
          <Button disabled={!file || !year || !quarter} onClick={onImport}>
            Submit
          </Button>
        }
        title="Import adoption decisions"
        open={open}
      />

      <Button disabled={hpKey === 999} onClick={() => setopen(true)}>
        Import Adoption Decisions
      </Button>
    </Box>
  );
};

export default ImportModal;
